import { graphql } from "@opensea/graphql"
import { getMediaPropsFromMediaFragment } from "../../../../utils"

export const BackgroundOnlyFragment = graphql(
  `
    fragment BackgroundOnly on CollectionNarrativeModule {
      desktopBackgroundMedia {
        ...MediaProps
      }
      mobileBackgroundMedia {
        ...MediaProps
      }
    }
  `,
  [getMediaPropsFromMediaFragment],
)
